import { Docs } from '@/docs/Docs';
import { closeDialog } from '@/stores/dialog';
import { useState } from 'react';

interface NavItem {
  title: string;
  path: string;
}

const navItems: NavItem[] = [
  { title: 'Home', path: '/' },
  { title: 'Getting Started', path: '/getting-started' },
  { title: 'Core Concepts', path: '/core-concepts' },
  { title: 'Creating Log Entries', path: '/creating-entries' },
  { title: 'Report Templates', path: '/report-templates' },
  { title: 'Code Words', path: '/code-words' },
  { title: 'Call Sign Shortcuts', path: '/call-sign-shortcuts' },
  { title: 'Operator Management', path: '/operators' },
  { title: 'Tags and Organization', path: '/tags' },
  { title: 'Exporting Data', path: '/exporting' },
  { title: 'Keyboard Shortcuts', path: '/keyboard-shortcuts' },
  { title: 'Offline Usage', path: '/offline-usage' },
  { title: 'View Modes', path: '/view-modes' },
  { title: 'Scheduled Reminders', path: '/scheduled-reminders' },
  { title: 'Server Connection', path: '/server-connection' },
  { title: 'Tips and Best Practices', path: '/tips' },
  { title: 'Troubleshooting', path: '/troubleshooting' },
  { title: 'FAQ', path: '/faq' },
];

export function DocsDialog() {
  const [docPath, setDocPath] = useState('/');

  return (
    <div className="stop-scrolling fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="flex h-[calc(100vh-2rem)] w-[calc(100vw-2rem)] flex-col overflow-hidden rounded-lg bg-white shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <h2 className="text-xl font-semibold text-gray-800">Documentation</h2>
          <button
            onClick={closeDialog}
            className="cursor-pointer rounded-md border border-gray-300 px-4 py-2 font-medium text-gray-700 hover:bg-gray-50"
          >
            Close
          </button>
        </div>

        {/* Content Area with Sidebar */}
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <nav className="w-64 overflow-y-auto border-r border-gray-200 bg-gray-50">
            <div className="p-4">
              <h3 className="mb-3 text-xs font-semibold tracking-wider text-gray-500 uppercase">
                Contents
              </h3>
              <ul className="space-y-1">
                {navItems.map(item => (
                  <li key={item.path}>
                    <button
                      onClick={() => setDocPath(item.path)}
                      className={`w-full cursor-pointer rounded-md px-3 py-2 text-left text-sm transition-colors ${
                        docPath === item.path
                          ? 'bg-blue-100 font-medium text-blue-700'
                          : 'text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {item.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Main Content */}
          <div className="flex-1 overflow-y-auto">
            <div className="p-6">
              <Docs path={docPath} goTo={setDocPath} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
